
<ng-container *ngIf="!!medias.length">
	<div class="hmf-display-flex hmf-flex-column"
		[ngClass]="{ 'hmf-pl-s': hasNewReviewsEnhancement(), 'hmf-mt-m' : !hideTitle()}">
		@if (!hideTitle()) {
			<p class="hmf-header-bold-s">Images</p>
		}
		<div class="hmf-display-flex hmf-align-items-center horizontal-scroll-container">
			<ng-container *ngIf="medias.length > 0">
				<product-reviews-review-slider class="slider-content" [selector]="selector()">
					<ul class="carousel-content hmf-display-flex hmf-p-0 hmf-m-0 hmf-pb-xxxs" carouselContent>
						<li *ngFor="let media of medias; let imageId = index; trackBy: trackByFn;" class="hmf-display-flex hmf-align-items-center hmf-justify-content-center" >
							<product-reviews-review-media
								[media]="media"
								[imageId]="imageId"
								[mediaSource]="mediaSource()"
								(selectedMedia)="handleReview($event)"
							></product-reviews-review-media>
						</li>
					</ul>
				</product-reviews-review-slider>
			</ng-container>
		</div>
	</div>

	<product-reviews-modal></product-reviews-modal>

</ng-container>

